import * as actionTypes from '../actions/actionTypes';
import {
  NotificationsState,
  normalizeEnvelope,
  normalizeRestItem,
} from '@/features/notifications/types';

const initialState: NotificationsState = {
  items: [],
  unreadCount: 0,
  unreadByType: {},
  lastSeq: 0,
  connection: 'idle',
  loading: false,
};

const notificationsReducer = (state = initialState, action): NotificationsState => {
  switch (action.type) {
    case actionTypes.NOTIFICATIONS_SNAPSHOT:
      return {
        ...state,
        unreadCount: action.data.unreadCount ?? state.unreadCount,
        unreadByType: action.data.unreadByType ?? state.unreadByType,
        lastSeq: Math.max(state.lastSeq, action.data.lastSeq ?? 0),
      };

    case actionTypes.NOTIFICATIONS_SET: {
      const items = (action.data.items ?? []).map(normalizeRestItem);
      const lastSeq = items.reduce((max, i) => Math.max(max, i.seq), state.lastSeq);
      return { ...state, items, lastSeq };
    }

    case actionTypes.NOTIFICATION_ADDED: {
      const item = normalizeEnvelope(action.data.envelope);
      if (state.items.some((i) => i.id === item.id)) {
        return state;
      }
      const items = [item, ...state.items].sort((a, b) => b.seq - a.seq);
      return {
        ...state,
        items,
        unreadCount: state.unreadCount + 1,
        lastSeq: Math.max(state.lastSeq, item.seq),
      };
    }

    case actionTypes.NOTIFICATION_MARKED_READ: {
      let wasUnread = false;
      const items = state.items.map((i) => {
        if (i.id === action.data.id && !i.isRead) {
          wasUnread = true;
          return { ...i, isRead: true };
        }
        return i;
      });
      return {
        ...state,
        items,
        unreadCount: wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount,
      };
    }

    case actionTypes.NOTIFICATIONS_ALL_READ:
      return {
        ...state,
        items: state.items.map((i) => ({ ...i, isRead: true })),
        unreadCount: 0,
        unreadByType: {},
      };

    case actionTypes.NOTIFICATION_REMOVED: {
      const removed = state.items.find((i) => i.id === action.data.id);
      const items = state.items.filter((i) => i.id !== action.data.id);
      const unreadCount =
        removed && !removed.isRead ? Math.max(0, state.unreadCount - 1) : state.unreadCount;
      return { ...state, items, unreadCount };
    }

    case actionTypes.NOTIFICATIONS_SET_UNREAD_COUNT:
      return { ...state, unreadCount: action.data.unreadCount ?? 0 };

    case actionTypes.NOTIFICATIONS_SET_CONNECTION:
      return { ...state, connection: action.data.connection };

    case actionTypes.NOTIFICATIONS_LOADING:
      return { ...state, loading: action.data.loading };

    default:
      return state;
  }
};

export default notificationsReducer;
